import { Wei } from '../../types'
import { useMarketIndexes } from '../../store/market/hooks'
import { useMemo } from 'react'
import { BigNumber } from 'ethers'
import { bn, e2w, w2e } from '../../utils/number'
import { usePerpPositions, usePerpSymbols } from '../../store/perp/hooks'

import { getMarkPriceFromIndexes } from '../../utils/getMarkPriceFromIndexes'

// The total USD value of the all positions.
export function usePositionValue(): Wei {
  const positions = usePerpPositions()
  const symbols = usePerpSymbols()
  const indexes = useMarketIndexes()

  return useMemo(() => {
    if (!positions || !symbols) return '0'
    const activePositions = positions.filter((v) => v.quantity > 0)
    if (!activePositions.length) return '0'
    const value = activePositions.reduce((prev, current): BigNumber => {
      const { symbolId } = current
      const { baseCurrency = '', multiplier = 0 } =
        symbols.find((v) => v.id === symbolId) ?? {}
      const markPrice = getMarkPriceFromIndexes(indexes, baseCurrency)
      const v = bn(e2w(current.quantity))
        .mul(e2w(multiplier))
        .mul(e2w(markPrice))
      return prev.add(v)
    }, bn('0'))
    return w2e(w2e(value))
  }, [positions, symbols, indexes])
}
